import { useTranslation } from 'react-i18next';

import { Filters, TFilterItem, RadioList } from '@treezor/design-system';

import { useSCAList } from '../hooks/useSCAList';

import CursorNavigation from '@/ui-kit/cursor-navigation/CursorNavigation';

import { SCATable } from './SCATable';

export function SCAList() {
  const { t } = useTranslation();

  const {
    selectedWallets,
    isLoading,
    statusOptions,
    filterStatus,
    handleFilterStatus,
    onResetFilter,
    cursor,
    handleCursor,
  } = useSCAList();

  const items: TFilterItem[] = [
    {
      id: 'filterStatus',
      label: t('pages.currentProfiles.profile.sca.status'),
      type: 'CUSTOM',
      selectedValues: [statusOptions.find((option) => option.value === filterStatus).label],
      dropdownContent: (
        <RadioList
          label=""
          options={statusOptions}
          value={filterStatus}
          onChange={handleFilterStatus}
          className="gap-4 p-5"
        />
      ),
      onReset: onResetFilter,
    },
  ];

  return (
    <div className="flex flex-col gap-5">
      <h6 className="typo-h6-bold text-secondary">{t('pages.currentProfiles.profile.sca.title')}</h6>
      <Filters
        labels={{
          filterButton: t('pages.cores.filter'),
          selectedValues: '',
          clearButton: t('pages.cores.clearFilters'),
        }}
        items={items}
        defaultFilters={['filterStatus']}
        onClearFilters={onResetFilter}
      />
      <div className="flex flex-col gap-2">
        <SCATable list={selectedWallets} isLoading={isLoading} />
        {cursor && <CursorNavigation cursor={cursor} handleCursor={handleCursor} />}
      </div>
    </div>
  );
}
